module.exports = __webpack_public_path__ + "img/source3_3.0cd9c2d8.png";